/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject, input, InputSignal, NgZone, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollService } from 'src/chatbot/service/scrollContainer.service';

@Component({
  selector: 'text-animation',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './text-animation.component.html',
  styleUrls: ['./text-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TextAnimationComponent {
  public phrases: InputSignal<string[]> = input.required<string[]>();
    
  private scrollService = inject(ScrollService);
  private destroyRef = inject(DestroyRef);
  private ngZone = inject(NgZone);

  public currentPhrase = signal('');
  public phraseVisible = signal(false);
  public phraseRenderKey = signal(0);

  private timers: ReturnType<typeof setTimeout>[] = [];
  private phraseIndex = 0;
  
  ngOnInit(){
    this.clearTimers();
    this.showNextPhrase();
    this.destroyRef.onDestroy(() => this.clearTimers());
  }

  private showNextPhrase() {
    const phrases = this.phrases();
    if (!phrases?.length) {
      this.currentPhrase.set('');
      this.phraseVisible.set(false);
      return;
    }

    this.phraseVisible.set(false);
    const fadeTimer = setTimeout(() => {
      this.ngZone.run(() => {
        const safeIndex = this.phraseIndex % phrases.length;
        this.currentPhrase.set(phrases[safeIndex]);
        this.phraseRenderKey.update((prev) => prev + 1);
        this.phraseIndex = (safeIndex + 1) % phrases.length;
        this.phraseVisible.set(true);
        this.scrollService.scrollToBottom();
      });

      if (phrases.length === 1)
        return; 

      const displayDuration = 1500 + Math.random() * 2000;
      const nextTimer = setTimeout(() => {
        this.ngZone.run(() => this.showNextPhrase());
      }, displayDuration);
      this.timers.push(nextTimer);
    }, 300);

    this.timers.push(fadeTimer);
  }

  private clearTimers() {
    this.timers.forEach(t => clearTimeout(t));
    this.timers = [];
  }

  ngOnDestroy(){
    this.clearTimers();
  }

}
